
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.4 24a1.38 1.38 0 01-1.16-.58 1.66 1.66 0 01-.06-1.64l2.1-5.18a9.26 9.26 0 011.76-2.65L17.34.7a2.47 2.47 0 013.4 0l2.55 2.55a2.38 2.38 0 010 3.4L10 19.88a9.67 9.67 0 01-2.64 1.77L2.24 23.8a2.16 2.16 0 01-.84.19zM19.03 1a1.37 1.37 0 00-.98.4L4.75 14.66a8.35 8.35 0 00-1.54 2.31l-2.1 5.2a.77.77 0 00-.05.68c.13.18.41.2.79.04l5.12-2.15a8.77 8.77 0 002.33-1.56L22.59 5.93a1.38 1.38 0 00.41-.98 1.4 1.4 0 00-.41-1l-2.56-2.54a1.4 1.4 0 00-1-.41z"}}),_c('path',{attrs:{"d":"M19.86 8.97a.5.5 0 01-.36-.14l-4.7-4.68a.5.5 0 01.7-.71l4.7 4.68a.5.5 0 01-.34.85z"}})])
          )
        }
      }
    